import './user_profile_attribute_view.js.coffee'

class Customer.BooleanUserProfileAttributeView extends Customer.UserProfileAttributeView
  template: JST["backbone/templates/customer/users/custom_attributes/boolean"]
  className: 'user-profile-attribute boolean-user-profile-attribute'

  render: ->
    @$el.html(@template(model: @model, viewID: @cid))
    @$el.find("input[name=\"boolean-custom-#{@model.get('definition').id}-#{@cid}\"]").on 'change', =>
      @trigger 'profile_custom_attributes:modified_field'
    @

  getAdded: ->
    definition_code: @model.get('definition').code,
    values: _.difference(@getValue(), @initialValues())

  getDeleted: ->
    definition_code: @model.get('definition').code,
    values: _.difference(@initialValues(), @getValue())

  getValue: ->
    if @$el.find("#yes-#{@model.get('definition').id}-#{@cid}").prop('checked')
      [true]
    else if @$el.find("#no-#{@model.get('definition').id}-#{@cid}").prop('checked')
      [false]
    else
      []

  disableFurtherChange: ->
    @$el.find('.radio-label').addClass('disabled')
